import { render, staticRenderFns } from "./stardisplay.vue?vue&type=template&id=240b773e&"
import script from "./stardisplay.vue?vue&type=script&lang=js&"
export * from "./stardisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('240b773e')) {
      api.createRecord('240b773e', component.options)
    } else {
      api.reload('240b773e', component.options)
    }
    module.hot.accept("./stardisplay.vue?vue&type=template&id=240b773e&", function () {
      api.rerender('240b773e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2JQ25hwKUE9fQ/JS/stardisplay.vue"
export default component.exports